/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowDefList } from './WorkflowDefList';
import {
    WorkflowDefListFromJSON,
    WorkflowDefListFromJSONTyped,
    WorkflowDefListToJSON,
    WorkflowDefListToJSONTyped,
} from './WorkflowDefList';

/**
 * 
 * @export
 * @interface PaginatedWorkflowDefListList
 */
export interface PaginatedWorkflowDefListList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedWorkflowDefListList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedWorkflowDefListList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedWorkflowDefListList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<WorkflowDefList>}
     * @memberof PaginatedWorkflowDefListList
     */
    results: Array<WorkflowDefList>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedWorkflowDefListList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedWorkflowDefListList interface.
 */
export function instanceOfPaginatedWorkflowDefListList(value: object): value is PaginatedWorkflowDefListList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedWorkflowDefListListFromJSON(json: any): PaginatedWorkflowDefListList {
    return PaginatedWorkflowDefListListFromJSONTyped(json, false);
}

export function PaginatedWorkflowDefListListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedWorkflowDefListList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(WorkflowDefListFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedWorkflowDefListListToJSON(json: any): PaginatedWorkflowDefListList {
    return PaginatedWorkflowDefListListToJSONTyped(json, false);
}

export function PaginatedWorkflowDefListListToJSONTyped(value?: PaginatedWorkflowDefListList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(WorkflowDefListToJSON)),
        'num_pages': value['numPages'],
    };
}

